import { Create, SimpleForm, TextInput } from 'react-admin'

const PdfCategoriesCreate = () => {
    return (
        <Create redirect="/pdf-categories">
            <SimpleForm>
                <TextInput source="name" fullWidth />
            </SimpleForm>
        </Create>
    )
}

export default PdfCategoriesCreate
